import React, { useState, useEffect } from 'react';
import { Download, FileText, Edit, Save, X } from 'lucide-react';
import apiService from '../config'; // Import the API service

const RailwayPunavarshan = () => {
  // State to store multiple owner records
  const [owners, setOwners] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentDate, setCurrentDate] = useState("");
  const [projectName, setProjectName] = useState("");

  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14
  };

  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

  // Function to fetch data from the getPAP API
  const fetchPAPData = async (projectId, proposalId) => {
    try {
      setLoading(true);
      const response = await apiService.get(`/getPAP?projectId=${projectId}&proposalId=${proposalId}`);
      // Map API response to owner data structure
      const ownerData = response.data.map((item, index) => ({
        id: item.land_owner_id || index, // Unique identifier for each owner
        applicantName: item.owner_name || '',
        applicantName1: item.owner_name || '',
        applicantName2: item.owner_name || '',
        applicantName3: item.owner_name || '',
        village: item.village_name || '',
        taluka: item.taluka_name || '',
        village1: item.village_name || '',
        taluka1: item.taluka_name || '',
        village2: item.village_name || '',
        taluka2: item.taluka_name || '',
        deceased: '',
        surveyNumber: item.survey_no || '',
        area: item.owner_aqr_area ? `${item.owner_aqr_area} Square Meters` : '',
        relation: '',
        registration: item.acquisition_proposal_no || '',
        pageno: '',
        description: item.remarks || '',
      }));
      setOwners(ownerData);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch data from the API');
      setLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    const today = new Date();
    const formatted = today.toLocaleDateString("en-GB"); // dd/mm/yyyy
    setCurrentDate(formatted);
  }, []);

  // Fetch data when the component mounts
  useEffect(() => {
    const projectId = '1'; // Replace with dynamic input if needed
    const proposalId = '25'; // Replace with dynamic input if needed
    fetchPAPData(projectId, proposalId);
  }, []);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    console.log('Saved data:', owners);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleInputChange = (ownerId, field, value) => {
    setOwners(prev =>
      prev.map(owner =>
        owner.id === ownerId ? { ...owner, [field]: value } : owner
      )
    );
  };

  // Fetch data when the component mounts
  useEffect(() => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    const selectedProposal = JSON.parse(localStorage.getItem("selectedProposal"));

    if (selectedProject) {
      setProjectName(selectedProject.project_name || "");  // 👈 Save project name
    }

    if (selectedProject && selectedProposal) {
      const projectId = selectedProject.id || selectedProject.project_id;
      const proposalId = selectedProposal.acquisition_proposal_id;
      fetchPAPData(projectId, proposalId);
    }
  }, []);



  const handleDownloadPDF = () => {
    const printContent = document.getElementById('pdf-content');
    const originalDisplay = document.body.style.display;

    // Hide everything except the PDF content
    const allElements = document.body.children;
    Array.from(allElements).forEach(el => {
      if (!el.contains(printContent)) {
        el.style.display = 'none';
      }
    });


    // Apply print styles for multiple pages
    const printStyles = `
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
        #pdf-content {
          width: 210mm;
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-size: 11px !important;
          line-height: 1.3 !important;
        }
        .page {
          page-break-after: always;
          page-break-inside: avoid;
          width: 210mm;
          min-height: 297mm;
          margin: 0;
          padding: 15mm;
          box-sizing: border-box;
        }
        .page:last-child {
          page-break-after: avoid;
        }
        @page {
          size: A4;
          margin: 0;
        }
        .space-y-4 > * + * {
          margin-top: 8px !important;
        }
        .space-y-1 > * + * {
          margin-top: 2px !important;
        }
        .mt-6 {
          margin-top: 12px !important;
        }
        .mt-12 {
          margin-top: 20px !important;
        }
        .mb-4 {
          margin-bottom: 8px !important;
        }
        .mb-6 {
          margin-bottom: 12px !important;
        }
        .p-4 {
          padding: 8px !important;
        }
        .px-6 {
          padding-left: 12px !important;
          padding-right: 12px !important;
        }
        .py-2 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
        input {
          border: none !important;
          background: transparent !important;
        }
      }
    `;

    const styleElement = document.createElement('style');
    styleElement.textContent = printStyles;
    document.head.appendChild(styleElement);

    // Trigger print
    window.print();

    // Restore original display
    setTimeout(() => {
      Array.from(allElements).forEach(el => {
        el.style.display = '';
      });
      document.head.removeChild(styleElement);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Action Buttons */}
        <div className="mb-6 flex justify-end gap-3">
          {!isEditing ? (
            <>
              {/* {userRole === ROLES.LAO && ( */}
              {/* Data Entry */}
              {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                <button
                  onClick={handleEdit}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors duration-200 shadow-lg"
                >
                  <Edit size={20} />
                  Edit
                </button>
              )}
              <button
                onClick={handleDownloadPDF}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors duration-200 shadow-lg"
              >
                <Download size={20} />
                Download PDF
              </button>
            </>
          ) : (
            <>
              <button
                onClick={handleCancel}
                className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors duration-200 shadow-lg"
              >
                <X size={20} />
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors duration-200 shadow-lg"
              >
                <Save size={20} />
                Save
              </button>
            </>
          )}
        </div>

        {/* Loading or Error State */}
        {loading && <div>Loading...</div>}
        {error && <div className="text-red-600">{error}</div>}

        {/* PDF Preview */}
        <div className="bg-white shadow-2xl">
          <div id="pdf-content">
            {owners.map((owner, index) => (
              <div key={owner.id} className="page bg-white p-8 min-h-screen" style={{ fontFamily: 'serif' }}>
                <div className="mb-6 border border-black p-4">
                  <div className="flex justify-end p-4">
                    <div className="border border-black text-sm">
                      <div className="px-6 py-2 border-b border-black">
                        रजि क्र.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.registration}
                            onChange={(e) => handleInputChange(owner.id, 'registration', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                            placeholder=""
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{owner.registration || '................'}</span>
                        )}
                      </div>
                      <div className="px-6 py-2">
                        पान क्र.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.pageno}
                            onChange={(e) => handleInputChange(owner.id, 'pageno', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100 bold"
                            placeholder=""
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{owner.pageno || '................'}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 space-y-1 text-sm">
                    <div>१. महाराष्ट्र शासन महसूल व वनमंत्रालय, शासन निर्णय क्रमांक उपायोजना क्र. ०४ वा /२०२१/प्र.क्र.३११/२०२१.</div>
                    <div>२. महाराष्ट्र शासन महसूल व वनमंत्रालय, शासन निर्णय क्रमांक आरपीएसएल/१४४७ दि.१२/०३/२० दि.२०/०४/२०२१.</div>
                    <div>३. महाराष्ट्र शासन महसूल व वनमंत्रालय, शासन निर्णय क्रमांक आरपीएसएल/०३०४ दि.१२/०८/२०२०.</div>
                    <div>४. महाराष्ट्र शासन महसूल व वनमंत्रालय, शासन निर्णय क्रमांक आरपीएसएल/०३०४ दि.२१/०४/२०२०.</div>
                    <div>५. महाराष्ट्र शासन महसूल व वनमंत्रालय, शासन निर्णय क्रमांक आरपीएसएल/०३०४ दि.२१/०४/२०२०.</div>
                  </div>

                  <div className="border-t border-dashed border-black mt-4"></div>

                  <div className="mt-6 text-sm">
                    <div>
                      अजेंदार :- १. श्री/श्रीमती
                      {isEditing ? (
                        <input
                          type="text"
                          value={owner.applicantName}
                          onChange={(e) => handleInputChange(owner.id, 'applicantName', e.target.value)}
                          className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                          placeholder="नाव"
                        />
                      ) : (
                        <span className="mx-2 border-b border-dotted">{owner.applicantName || '.........................'}</span>
                      )}
                      रा
                      {isEditing ? (
                        <input
                          type="text"
                          value={owner.village}
                          onChange={(e) => handleInputChange(owner.id, 'village', e.target.value)}
                          className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                          placeholder="गाव"
                        />
                      ) : (
                        <span className="mx-2 border-b border-dotted">{owner.village || '................'}</span>
                      )}
                      वा
                      {isEditing ? (
                        <input
                          type="text"
                          value={owner.taluka}
                          onChange={(e) => handleInputChange(owner.id, 'taluka', e.target.value)}
                          className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                          placeholder="तालुका"
                        />
                      ) : (
                        <span className="mx-2 border-b border-dotted">{owner.taluka || '................'}</span>
                      )}
                      जि. बुलढाणा यांचा अर्ज
                    </div>
                    <div className="ml-16">दि. {currentDate}</div>
                    <div className="ml-14">
                      २. उपजिल्हाधिकारी भूसंपादन (मध्यम प्रकल्प) बुलढाणा यांचे पत्र दि. {currentDate}
                    </div>
                    <div className="mt-4 text-right">
                      <div>जा.क्र. कावि/कक्ष/२१/ पुनर्वसन/ /२०२५</div>
                      <div>जिल्हाधिकारी कार्यालय, बुलढाणा</div>
                      <div>दिनांक :- {currentDate}</div>
                    </div>
                  </div>

                  {/* Main Content */}
                  <div className="text-center mb-4">
                    <h2 className="text-lg font-bold underline">प्रमाणपत्र</h2>
                  </div>

                  <div className="space-y-4 text-sm leading-relaxed">
                    <div>
                      <span className="font-semibold mr-2">१.</span> दाखल येण्यात येतो की, <strong>श्री.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.applicantName}
                            onChange={(e) => handleInputChange(owner.id, 'applicantName', e.target.value)}
                            className="border-b border-gray-400 mx-1 px-1 bg-yellow-100"
                            placeholder="नाव"
                          />
                        ) : (
                          <span className="mx-1 border-b border-dotted">{owner.applicantName || '-----------'}</span>
                        )}
                        रा.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.village1}
                            onChange={(e) => handleInputChange(owner.id, 'village1', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                            placeholder="गाव"
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{owner.village1 || '............'}</span>
                        )}
                        ता.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.taluka1}
                            onChange={(e) => handleInputChange(owner.id, 'taluka1', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                            placeholder="तालुका"
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{owner.taluka1 || '............'}</span>
                        )}
                        जि.बुलढाणा यांचे मालकीचे
                      </strong>
                      <span className="ml-1"><strong>
                        जि.बुलढाणा येथील गट नं.सर्व्हे  नं.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.surveyNumber}
                            onChange={(e) => handleInputChange(owner.id, 'surveyNumber', e.target.value)}
                            className="border-b border-gray-400 mx-1 px-1 bg-yellow-100"
                            placeholder="सर्व्हे  नंबर"
                          />
                        ) : (
                          <span className="mx-1 border-b border-dotted">{owner.surveyNumber || '------'}</span>
                        )}
                        मधील
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.area}
                            onChange={(e) => handleInputChange(owner.id, 'area', e.target.value)}
                            className="border-b border-gray-400 mx-1 px-1 bg-yellow-100"
                            placeholder="क्षेत्रफळ"
                          />
                        ) : (
                          <span className="mx-1 border-b border-dotted">{owner.area || '-------'}</span>
                        )}
                        हे.आर जमीन
                        {isEditing ? (
                          <input
                            type="text"
                            value={projectName}
                            onChange={(e) => handleInputChange(owner.id, 'projectName', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                            placeholder=""
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{projectName || '.........................'}</span>
                        )}
                        प्रकल्पाचे</strong></span>
                      <span className="ml-2"><strong>बुडीत क्षेत्राच्या प्रयोजनासाठी संपादीत केल्यामुळे श्री.
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.applicantName2}
                            onChange={(e) => handleInputChange(owner.id, 'applicantName2', e.target.value)}
                            className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                            placeholder="नाव"
                          />
                        ) : (
                          <span className="mx-2 border-b border-dotted">{owner.applicantName2 || '.........................'}</span>
                        )}
                        प्रकल्पग्रस्त व्यक्ति आहेत.</strong></span>
                    </div>

                    <div>
                      <span className="font-semibold mr-2">२.</span> दाखला देण्यात येतो की
                      {isEditing ? (
                        <input
                          type="text"
                          value={owner.applicantName3}
                          onChange={(e) => handleInputChange(owner.id, 'applicantName3', e.target.value)}
                          className="border-b border-gray-400 mx-2 px-1 bg-yellow-100"
                          placeholder="नाव"
                        />
                      ) : (
                        <span className="mx-1 border-b border-dotted">{owner.applicantName3 || '.........................'}</span>
                      )}
                      ही उपरोक्त परीच्छेदात उल्लेख केलेल्या प्रकल्पग्रस्त
                      <span className="ml-1">व्यक्तिच्या कुटुंबातील आणि तिच्यावर अवलंबून असणारी व्यक्ति असून त्यांचे प्रकल्पग्रस्त व्यक्तिशी नाते</span>
                      <span className="ml-1">
                        {isEditing ? (
                          <input
                            type="text"
                            value={owner.relation}
                            onChange={(e) => handleInputChange(owner.id, 'relation', e.target.value)}
                            className="border-b border-gray-400 mx-1 px-1 bg-yellow-100"
                            placeholder="नाते"
                          />
                        ) : (
                          <span className="mx-1 border-b border-dotted">{owner.relation || '------'}</span>
                        )}
                        आहे.</span>
                    </div>

                    <div>
                      <span className="font-semibold mr-2">३.</span> शासनाच्या पुनर्वसन योजने अंतर्गत सदर प्रकल्पग्रस्त व्यक्तीला किंवा तिच्या कुटुंबातील आणि
                      <span className="ml-1">तिच्यावर अवलंबुन असणाऱ्या उपरोक्त एकाच व्यक्तीला नोकरी मिळण्याचे संदर्भात सदर दाखला</span>
                      <span className="ml-1">परिणामकारक राहिल आणि वरील प्रमाणे संबंधित व्यक्तीला नोकरी मिळाल्यावर दाखल्याची परिणामकारकता रद्द होईल.</span>
                    </div>

                    <div>
                      <span className="font-semibold mr-2">४.</span> वरील दाखल्याचे आधारे प्रकल्पग्रस्त व्यक्ती किंवा तिच्यावर अवलंबुन असणा-या एका व्यक्तिला
                      <span className="ml-1">नोकरी देण्याची कार्यवाही करण्या-या कार्यालयाने नोकरी दिल्याचा तपशील उपजिल्हाधिकारी पुनर्वसन</span>
                      <span className="ml-1">बुलढाणा यांचेकडे तात्काळ कळविणे आवश्यक आहे. तसेच हे मुळ प्रमाणपत्र त्यांचे कार्यालयाचे दप्तरी</span>
                      <span className="ml-1">दाखल करुन घेण्यात यावे. तसेच अर्जदाराने सादर केलेली कागदपत्र दिशाभुल करणारी चुकीचे सादर केल्याचे</span>
                      <span className="ml-1">निर्देशनास आल्यास सदर प्रमाणपत्र रद्द करण्यात करण्यात येईल.</span>
                    </div>
                  </div>

                  {/* Signature Section */}
                  <div className="mt-12 text-right">
                    <div className="text-sm">
                      <div>(सदाशिव शेलार)</div>
                      <div><strong>जिल्हा पुनर्वसन अधिकारी</strong></div>
                      <div><strong>बुलढाणा</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Print-specific styles */}
      <style jsx>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #pdf-content,
          #pdf-content * {
            visibility: visible;
          }
          #pdf-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default RailwayPunavarshan;